module.exports = __webpack_public_path__ + "static/media/calendar.185659ff.png";